// extracted by mini-css-extract-plugin
export var measureBox = "_a2-0";